var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoriteIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "starGradient",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffe61c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffa929"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21777 1.01562C9.54234 0.32874 10.4577 0.328739 10.7822 1.01562L13.126 5.97363L13.2402 6.21484L13.5029 6.25488L18.7451 7.0498C19.441 7.15531 19.778 8.09335 19.2256 8.65625L15.4336 12.5166L15.2549 12.6973L15.2959 12.9482L16.1914 18.3975C16.3247 19.211 15.5281 19.7233 14.9277 19.3936L10.2412 16.8213L10.001 16.6895L9.75977 16.8213L5.07227 19.3936C4.5092 19.7027 3.77349 19.2715 3.79395 18.5459L3.80859 18.3975L4.7041 12.9482L4.74512 12.6973L4.56738 12.5166L0.774414 8.65625L0.680664 8.54688C0.26589 7.98127 0.601338 7.1489 1.25488 7.04883L6.49609 6.25488L6.75977 6.21484L6.87402 5.97363L9.21777 1.01562Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteIcons);
export default __webpack_public_path__ + "static/media/favorite-icons.978d32596c33bf7a3865858ef80be7fc.svg";
export { ForwardRef as ReactComponent };